import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const TARGET = new Date("2026-08-02T18:00:00+05:30").getTime();

const getLeft = () => {
  const diff = Math.max(0, TARGET - Date.now());
  return {
    Days: Math.floor(diff / 86400000),
    Hours: Math.floor(diff / 3600000) % 24,
    Mins: Math.floor(diff / 60000) % 60,
    Secs: Math.floor(diff / 1000) % 60,
  };
};

export const CountdownSection = () => {
  const [left, setLeft] = useState(getLeft());

  useEffect(() => {
    const t = setInterval(() => setLeft(getLeft()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <motion.section
      className="sec snap-sec"
      data-testid="countdown-section"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8 }}
    >
      <div className="sec-title f-corm">The Celebration Begins In</div>
      <div className="cd-row" data-testid="countdown">
        {Object.entries(left).map(([label, num]) => (
          <div key={label} className="cd-box">
            <div className="cd-num f-corm" data-testid={`countdown-${label.toLowerCase()}`}>{num}</div>
            <div className="cd-label f-corm">{label.toUpperCase()}</div>
          </div>
        ))}
      </div>
      <img src="/assets/divider.png" alt="" className="orn-divider" />
    </motion.section>
  );
};
